import React from "react";
import { Route, Routes } from "react-router-dom";
import Tasks from "../pages/tasks/Tasks";

export default function TaskRoutes() {
  return (
    <Routes>
      <Route path="" element={<Tasks />} />
    </Routes>
  );
}
